import { $authHost } from 'app/configs/axiosConfig';
import { INotifications, INotificationFilteringOptions } from '../types';

export const getNotificationsAll = (params?: INotificationFilteringOptions) => {
  return $authHost.get<INotifications>('/notifications', {
    params,
    paramsSerializer: (params) => {
      let result = '';
      Object.keys(params).forEach((key) => {
        if (params[key]) result += `${key}=${encodeURIComponent(params[key])}&`;
      });
      return result.substring(0, result.length - 1);
    },
  });
};

export const readAllNotifications = () => {
  return $authHost.patch('/notifications/read-all');
};

export const deleteAllNotifications = () => {
  return $authHost.delete('/notifications');
};

export const deleteByIdNotifications = (notificationId: number) => {
  return $authHost.delete(`/notifications/${notificationId}`);
};
